import SimulatorLiguilla from "../components/simulatorTables/simulatorLiguilla";

export default function SimulatorPage() {

  return (
    <div className="simulador-page">
      <SimulatorLiguilla title="Jornada 17" />
    </div>
  );
}